var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhistleOutlineMod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499998 6.3499998",
    id: "svg106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-80.505529,-129.6458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 81.503762,130.62479 -0.428625,0.31221 0.605896,0.8255 c 0.16073,-0.0844 0.331387,-0.14843 0.508,-0.1905 m 1.230313,0.45509 v 0.52916 h 1.852083 l -0.05846,0.16022 -1.240828,0.16226 -0.02362,0.86812 c -0.02885,1.06041 -1.282472,1.59186 -2.032483,0.84185 -0.750011,-0.75001 -0.218948,-2.03248 0.841858,-2.03248 h 0.132292 v -0.52916 h -0.132301 c -1.532278,0 -2.299367,1.85246 -1.216014,2.93581 1.083354,1.08335 2.935806,0.31626 2.935806,-1.21602 v -0.42069 l 1.828459,-0.28785 0.02362,-1.01125 m -1.524,-1.4023 -0.632354,0.87313 h 0.653521 l 0.407458,-0.56092 m -2.344208,-0.762 v 1.32292 h 0.529167 v -1.32292 z",
    id: "path108",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistleOutlineMod);
export default __webpack_public_path__ + "static/media/whistle-outline-mod.624a80d7bbfa132c3b554c634e00e5cb.svg";
export { ForwardRef as ReactComponent };